import styled from 'styled-components';
import { IBlockBannerProps } from './BlockBanner.types';

export const BlockBannerWrapper = styled.div<IBlockBannerProps>`
  width: 100%;
  height: 220px;
  background: linear-gradient(45deg, #820000 0%, #e60000 100%);
  display: flex;

  align-items: center;
  padding: ${({ tarriffPage }) =>
    tarriffPage ? '0px 155px 0px 175px' : 'auto'};
  justify-content: ${({ tarriffPage }) =>
    tarriffPage ? 'flex-start' : 'center'};
  @media screen and (max-width: 480px) {
    height: 236px;
    width: 100%;
    padding: 0px;
  }
`;

export const BlockBannerBackgroundImageWrapper = styled.div<IBlockBannerProps>`
  width: 1030px;
  height: 100%;
  z-index: 0;
  display: flex;

  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  @media screen and (max-width: 1300px) {
    width: 100%;
    justify-content: center;
  }
  @media screen and (max-width: 480px) {
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(${({ mobileBackgroundImage }) =>
      mobileBackgroundImage ? mobileBackgroundImage : mobileBackgroundImage});
  }
`;

export const BannerText = styled.div<IBlockBannerProps>`
  width: 100%;
  height: 93.8px;
  text-align: left;
  color: white;
  font-size: 40px;
  font-weight: 400;
  line-height: 48px;
  text-align: left;

  #text1 {
    font-weight: 400;
  }

  @media screen and (max-width: 480px) {
    max-width: 420px;
    height: auto;
    margin-top: -100px;
    padding: 12px;
    font-size: 21px;
    font-weight: 400;
    line-height: 30px;
    text-align: center;
  }
`;

export const BannerImage = styled.div<IBlockBannerProps>`
  z-index: 0;

  span {
  }
  @media screen and (max-width: 480px) {
    display: none;
  }
  @media screen and (max-width: 2340px) {
  }
`;
